import React, { useState, useEffect } from "react";
import {
    ENABLE_QR_SURVEY,
    QR_SURVEY_URL,
    QR_SURVEY_NOTE,
    QR_SURVEY_PARAMS,
} from "app/appConfig";
import { handleGetQRCodeByValue } from "app/common/LocalFunction";

const QrSurveySection = ({ patient }) => {
    const [qrCode, setQrCode] = useState(null);

    const parseSurveyParams = (raw) => {
        if (!raw) return [];

        if (Array.isArray(raw)) return raw;

        if (typeof raw !== "string") return [];

        let value = raw.trim();

        // Remove trailing comma before ]
        value = value.replace(/,\s*]/g, "]");

        // Add quotes to keys if missing
        value = value.replace(/([{,]\s*)([a-zA-Z0-9_]+)(\s*:)/g, '$1"$2"$3');

        try {
            return JSON.parse(value);
        } catch (e) {
            console.error("Invalid QR_SURVEY_PARAMS:", e);
            return [];
        }
    };

    useEffect(() => {
        if (!ENABLE_QR_SURVEY || !QR_SURVEY_URL || !patient) return;

        const params = new URLSearchParams();

        const surveyParams = parseSurveyParams(QR_SURVEY_PARAMS);

        surveyParams.forEach(({ attr, param }) => {
            const value = patient?.[attr];
            if (value !== undefined && value !== null) {
                params.append(param || attr, value);
            }
        });

        const queryString = params.toString();
        const fullUrl = queryString
            ? `${QR_SURVEY_URL}${QR_SURVEY_URL.includes("?") ? "&" : "?"}${queryString}`
            : QR_SURVEY_URL;

        handleGetQRCodeByValue(fullUrl).then(setQrCode);

    }, [patient]);

    if (!ENABLE_QR_SURVEY || !qrCode) {
        return null;
    }

    return (
        <div
            className="qr-survey-container"
            style={{
                marginTop: "10px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
            }}
        >
            <img
                src={qrCode}
                alt="QR Khảo sát"
                style={{ width: "100px", height: "100px" }}
            />
            {QR_SURVEY_NOTE && (
                <div
                    className="qr-survey-note"
                    style={{
                        fontSize: "10px",
                        marginTop: "5px",
                        fontStyle: "italic",
                    }}
                >
                    {QR_SURVEY_NOTE}
                </div>
            )}
        </div>
    );
};

export default QrSurveySection;
